module.exports = __webpack_public_path__ + "static/media/tel.f33867bd.svg";